import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Link, withRouter } from 'react-router'
import cls from 'classnames'
import store from '../store'
import styles from './index.module.less'

@observer
class Menu extends Component {
  render() {
    const { location } = this.props
    return (
      <div className={styles['menu-wrap']}>
        <ul className={styles.menu}>
          {
            store.menus.map(item => (
              <Link
                key={item.value}
                className={cls({ [styles.active]: location.pathname === item.to })}
                onClick={() => store.switchMenu(`${item.to}?id=${location.query.id}`, location.pathname)}
              >
                <li className={styles['menu-item']}>
                  <i className={cls('iconfont', item.icon, styles.icon)}></i>
                  <div>{item.text}</div>
                </li>
              </Link>
            ))
          }
        </ul>
      </div>
    )
  }
}

export default withRouter(Menu)
